module.exports = __webpack_public_path__ + "static/media/logo-jp.178b1921.png";